const BASE_KEY = 'payg-topup';

export const paygQueryKeys = {
  balances: (accountId: string) => [BASE_KEY, 'balances', accountId],
  topups: (accountId: string) => [BASE_KEY, 'topups', accountId],
  pendingTopups: (accountId: string) => [BASE_KEY, 'pending', accountId],
  config: (accountId: string) => [BASE_KEY, 'config', accountId],
  initiateTopup: (accountId: string) => [BASE_KEY, 'initiate', accountId],
};
